export const tierOptions = [
  {
    label: "Starter",
    value: "starter",
  },
  {
    label: "Scale",
    value: "scale",
  },
  {
    label: "Business",
    value: "business",
  },
  {
    label: "Enterprise",
    value: "enterprise",
  },
];

export const providerOptions = [
  {
    label: "Asaas",
    value: 0,
  },
  {
    label: "Pagar.me",
    value: 1,
  },
  {
    label: "Bank",
    value: 2,
  },
  {
    label: "Partner",
    value: 3,
  },
];

export const paymentMethodOptions = [
  {
    label: "Boleto",
    value: 0,
  },
  {
    label: "Wire transfer",
    value: 1,
  },
  {
    label: "Credit Card",
    value: 2,
  },
  {
    label: "Transfer",
    value: 4,
  },
  {
    label: "Other",
    value: 3,
  },
];

export const statusOptions = [
  {
    id: 1,
    slug: "waiting",
    name: "Aguardando",
  },
  {
    id: 2,
    slug: "active",
    name: "Ativo",
  },
  {
    id: 3,
    slug: "expired",
    name: "Expirado",
  },
  {
    id: 4,
    slug: "cancelled",
    name: "Cancelado",
  },
];
